import React, { useEffect, useState } from 'react';
import { isEmptyEffect } from '@meitu/saas-editor-core/es/utils/layer-kit';
import { IImageLayerProps, LayerType } from '@meitu/saas-editor-core/es/version-types';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import effectPng from '@meitu/saas-editor-ui/es/panels/image-layer-panel/components/effect-panel/assets/effect00.png';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import './image-effect-menu.less';

const ImageEffectMenu: React.FC<{
    selectPanel: Function;
    imgEffectPreview: string;
    layerId: string;
}> = ({ selectPanel, layerId }) => {
    const { $t } = useLocaleStore();
    const [showImgEffectPreview, setShowImgEffectPreview] = useState(false);

    const effect = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { effect } = layer.data as IImageLayerProps;
        return effect;
    });

    useEffect(() => {
        if (!layerId) return;
        const activeLayer = editor.services.flatLayer.getLayer(layerId);

        if (!activeLayer || activeLayer.layerType !== LayerType.IMAGE_LAYER) {
            setShowImgEffectPreview(false);
            return;
        }

        const { data } = activeLayer;
        const { effect } = data as IImageLayerProps;

        if (!effect || isEmptyEffect(data as IImageLayerProps)) {
            setShowImgEffectPreview(false);
            return;
        } else {
            setShowImgEffectPreview(true);
        }
    }, [effect]);

    if (!layerId) {
        return null;
    }

    return (
        <div className="c-image-effect-menu">
            {/* <title className="title">图片特效</title> */}

            <div
                className="select"
                onClick={() => {
                    selectPanel();
                }}
            >
                <div className="block">
                    {showImgEffectPreview ? (
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <svg
                                width="56"
                                height="42"
                                viewBox={`0 0 ${160} ${118}`}
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                version="1.1"
                                xmlSpace="preserve"
                            >
                                <defs>
                                    <filter id="glow">
                                        <feDropShadow
                                            dx="0"
                                            dy="0"
                                            stdDeviation="5"
                                            floodColor="yellow"
                                            floodOpacity="0.5"
                                        ></feDropShadow>
                                    </filter>
                                </defs>

                                <defs>
                                    <filter id="shadow">
                                        <feDropShadow
                                            dx="0"
                                            dy="0"
                                            stdDeviation="5"
                                            floodColor="#000"
                                            floodOpacity="0.5"
                                        ></feDropShadow>
                                    </filter>
                                </defs>

                                <rect
                                    x="23"
                                    y="17"
                                    height="84"
                                    width="114"
                                    rx="15"
                                    fill="#000000"
                                    filter="url(#glow)"
                                ></rect>

                                <rect
                                    x="23"
                                    y="17"
                                    height="84"
                                    width="114"
                                    rx="15"
                                    fill="#000000"
                                    filter="url(#shadow)"
                                ></rect>

                                <rect
                                    x="23"
                                    y="17"
                                    height="84"
                                    width="114"
                                    stroke="#fff"
                                    fill="none"
                                    rx="15"
                                    strokeWidth="10"
                                ></rect>
                                <image x="23" y="17" height={84} width={114} xlinkHref={effectPng} />
                            </svg>
                        </div>
                    ) : (
                        <IconFont fontSize={26} name="PlusBold" />
                    )}
                </div>
                <span className="text">{$t((v) => v.panel.imagePanel.effect)}</span>

                <div className="arrow">
                    <IconFont fontSize={12} name="ChevronDownBlack" />
                </div>
            </div>
        </div>
    );
};

export default ImageEffectMenu;
